<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
                <div class="col-lg-5">
                    <card type="secondary" shadow
                          header-classes="bg-white pb-5"
                          body-classes="px-lg-5 py-lg-5"
                          class="border-0">
                        <!-- <template>
                            <div class="text-muted text-center mb-3">
                                <small>Sign in with</small>
                            </div>
                            <div class="btn-wrapper text-center">
                                <base-button type="neutral">
                                    <img slot="icon" src="img/icons/common/github.svg">
                                    Github
                                </base-button>

                                <base-button type="neutral">
                                    <img slot="icon" src="img/icons/common/google.svg">
                                    Google
                                </base-button>
                            </div>
                        </template> -->
                        <template>
                            <div class="text-center text-muted mb-4">
                                <small>sign up with Follow Me Traveller / HotelLele</small>
                            </div>
                            <form role="form">
                                <base-input alternative
                                            class="mb-3"
                                            v-model="registername"
                                            placeholder="Full Name *"
                                            addon-left-icon="ni ni-hat-3">
                                </base-input>
                                <base-input alternative
                                            class="mb-3"
                                            v-model="registeremail"
                                            placeholder="Email *"
                                            addon-left-icon="ni ni-email-83">
                                </base-input>
                                 <base-input alternative
                                            class="mb-3"
                                            v-model="registerphone"
                                            placeholder="Mobile No *"
                                            addon-left-icon="ni ni-mobile-button">
                                </base-input>
                                <base-input alternative
                                            type="password"
                                            v-model="registerpassword"
                                            placeholder="Password *"
                                            addon-left-icon="ni ni-lock-circle-open">
                                </base-input>
                                <!-- <div class="text-muted font-italic">
                                    <small>password strength:
                                        <span class="text-success font-weight-700">strong</span>
                                    </small>
                                </div> -->
                                <!-- <base-checkbox>
                                    <span>I agree with the
                                        <a href="#">Privacy Policy</a>
                                    </span>
                                </base-checkbox> -->
                                <div>
                                    <h6 style="color: #b5b5b5;">
                                        <input type="checkbox" name='termsandservices' v-model="termsandservices" >
                                        By creating an account with us, you agree to <a href="#/terms" target="_blank">our terms of services and privacy policy</a></h6>
                                </div>
                                <div v-show="show" id="" class=" logininfobox alert alert-warning mt-2">{{ registerErrorString }}</div>
                                <div v-show="showLoading" id="" class=" logininfobox alert alert-warning mt-2">Please wait...</div>
                                <div v-show="showSuccess" id="" class=" logininfobox alert alert-success mt-2">Thank you, your account was created succesfully, you can now login</div>
                                <div class="text-center">
                                    <base-button @click="registerProcess" type="primary" class="my-4">Create account</base-button>
                                </div>
                            </form>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { APIURLS } from "../api/constants.js";
import axios from "axios";

export default {
    name: "Register",
    data() {
        return {
            show: false,
            registername: "",
            registeremail: "",
            registerpassword: "",
            registerphone: "",
            showSuccess: false,
            showLoading: false,
            termsandservices:false,
            registerErrorString: "Unable to create your account, please try again later",
        }
    },
    methods: {
        registerProcess() {
            
            if(this.registername == '' || this.registeremail == '' || this.registerpassword == '' || this.registerphone == ''  || this.termsandservices!=
            false) {
                this.show = true;
                
                this.registerErrorString = "All fields are required for registration, please recheck and continue"
            } else {
                this.showLoading = true;
                this.show = false;
                //this.show = false;
                var formData = new FormData();
                formData.append('namesurname',this.registername);
                formData.append('contact','1');
                formData.append('email',this.registeremail);
                formData.append('password',this.registerpassword);
                formData.append('phone',this.registerphone);
                axios.post(APIURLS.REGISTER_URL, formData).then((response) => {
                    this.showLoading = false;
                    var data = response.data;
                    if(data.success) {
                        this.showSuccess = true;                        
                    } else {
                        this.registerErrorString = data.message;
                        this.show = true;
                    }
                    //console.log(response);
                });
                
            }
            
        },
    }
};
</script>
<style>
</style>
